module.exports = __webpack_public_path__ + "assets/images/premium-locked-screen/tag/filter-cbab50.png";